module.exports = __webpack_public_path__ + "static/media/save.879d88fd.svg";